import { AutogenLayoutTractorsNearDestinationReport } from "./autogen/AutogenLayoutTractorsNearDestinationReport";
import {  ChangeEvent,  BlurEvent, LookupModelSearchEvent } from "@mcleod/components";

export class TractorsNearDestinationReport extends AutogenLayoutTractorsNearDestinationReport {

    onLoad() {
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.excludabletextboxStates.visible = true;
        this.excludabletextboxZones.visible = false;
    }

    /** This is an event handler for the onChange event of switchStateZone. */
    switchStateZoneOnChange(event: ChangeEvent) {
        if (this.switchStateZone.checked) {
            this.excludabletextboxStates.textbox.clear();
            this.excludabletextboxStates.visible = false;
            this.excludabletextboxZones.visible = true;
        } else {
            this.excludabletextboxZones.textbox.clear();
            this.excludabletextboxZones.visible = false;
            this.excludabletextboxStates.visible = true;
        }
    }

    /** This is an event handler for the onBlur event of textboxMilesFromDest. */
    textboxMilesFromDestOnBlur(event: BlurEvent) {
        if (event.domEvent != null) {
            if (this.textboxMilesFromDest.isEmpty()) {
                this.textboxMilesFromDest.text = "50";
            }
        }
    }

    textboxOpsUserBeforeLookupModelSearch(event: LookupModelSearchEvent): void {
        event.filter.web_user_type = "U || E";
    }

}
